import React, { Component } from "react";
import axios from "axios";
import BackgroundView from "./BackgroundView";
import LayerView from "./LayerView";
import Menu from '../../Menu/Menu'
import Footer from '../../Footer/Footer'
import './View.css'

import CreatePayment from '../Payment/CreatePayment'

class View extends Component {
  constructor(props) {
    super();
    this.state = {
      loaded: false,
      url: window.location.href,
      productNumber: -1,
      productPrice: 0.00
    };
  }

  loadstate = () => {
    axios({
      url: "https://api.caigoycreations.com/projects/getprojectunique?GUId="+this.props.match.params.GUID,
      method: "get"
    }).then(
      res => {
        let tempState = res.data.data;
        console.log(res.data.data);

        //set product and price
        this.setState({
          productNumber: tempState.Product.Id,
          productPrice: tempState.Product.Price
        })

        let ratio = 300/res.data.data.DashboardWidth
        for (let i = 0; i < tempState.Inputs.length; i++){
          //calculate left:
          tempState.Inputs[i].Left = (tempState.Inputs[i].Left-tempState.DashboardLeft)*ratio 

          //calculate top:
          tempState.Inputs[i].Top = (tempState.Inputs[i].Top-tempState.DashboardTop)*ratio + 100

          //calculate width
          tempState.Inputs[i].Width = (tempState.Inputs[i].Width)*ratio

          ///calculate height
          tempState.Inputs[i].Height = (tempState.Inputs[i].Height)*ratio

        }

        //fill layers
        let tempLayerArray = [];
        for (let i = 0; i < tempState.Inputs.length; i++) {
          tempLayerArray.push(
            <LayerView
              parentUpdate={tempState.parentUpdate}
              index={i}
              key={i}
              visible={tempState.Inputs[i].Visible}
              //visible={true}
              //text
              text={tempState.Inputs[i].Text}
              textColor={tempState.Inputs[i].TextColor}
              font={tempState.Inputs[i].Font}
              fontSize={tempState.Inputs[i].FontSize}
              fontWeight={tempState.Inputs[i].FontWeight}
              fontStyle={tempState.Inputs[i].FontStyle}
              textAlign={tempState.Inputs[i].TextAlign}
              textDecoration={tempState.Inputs[i].TextDecoration}
              lineHeight={tempState.Inputs[i].LineSpace}
              textOpacity={tempState.Inputs[i].TextOpacity}
              //background
              backgroundColor={tempState.Inputs[i].BackgroundColor}
              opacity={tempState.Inputs[i].Opacity}
              //position
              left={tempState.Inputs[i].Left}
              top={tempState.Inputs[i].Top}
              width={tempState.Inputs[i].Width}
              height={tempState.Inputs[i].Height}
              rotateAngle={tempState.Inputs[i].RotateAngle}
              //picture
              isImage={tempState.Inputs[i].IsImage}
              imageUrl={tempState.Inputs[i].ImageUrl}
              ratio={tempState.Inputs[i].Ratio}
              pictureOpacity={tempState.Inputs[i].PictureOpacity}
              //border
              borderThickness={tempState.Inputs[i].BorderThickness}
              borderColor={tempState.Inputs[i].BorderColor}
              //callback to get child values
              parentsCallback={this.callbackFunction}
            />
          );
        }
        tempState.layers = tempLayerArray;
        tempState.loaded = true;
        this.setState(tempState);
        //this.forceUpdate();
      },
      err => {
        alert("connection to api failed, please upload again" + err.data);
        console.log(err.data);
      }
    );
  };

  //displays each layer
  displayLayers = () => {
    let tempLayerArray = [];
    for (let i = 0; i < this.state.Inputs.length; i++) {
      tempLayerArray.push(
        <LayerView
          parentUpdate={this.state.parentUpdate}
          index={i}
          key={i}
          visible={this.state.Inputs[i].Visible}
          //text
          text={this.state.Inputs[i].Text}
          textColor={this.state.Inputs[i].TextColor}
          font={this.state.Inputs[i].Font}
          fontSize={this.state.Inputs[i].FontSize}
          fontWeight={this.state.Inputs[i].FontWeight}
          fontStyle={this.state.Inputs[i].FontStyle}
          textAlign={this.state.Inputs[i].TextAlign}
          textDecoration={this.state.Inputs[i].TextDecoration}
          lineHeight={this.state.Inputs[i].LineSpace}
          textOpacity={this.state.Inputs[i].TextOpacity}
          //background
          backgroundColor={this.state.Inputs[i].BackgroundColor}
          opacity={this.state.Inputs[i].Opacity}
          //position
          left={this.state.Inputs[i].Left}
          top={this.state.Inputs[i].Top}
          width={this.state.Inputs[i].Width}
          height={this.state.Inputs[i].Height}
          rotateAngle={this.state.Inputs[i].RotateAngle}
          //picture
          isImage={this.state.Inputs[i].IsImage}
          imageUrl={this.state.Inputs[i].ImageUrl}
          ratio={this.state.Inputs[i].Ratio}
          pictureOpacity={this.state.Inputs[i].PictureOpacity}
          //border
          borderThickness={this.state.Inputs[i].BorderThickness}
          borderColor={this.state.Inputs[i].BorderColor}
          //callback to get child values
          parentsCallback={this.callbackFunction}
        />
      );
    }

    return tempLayerArray;
  };

  //used to syncronize child and parent components
  callbackFunction = childData => {
    let tempInputs = this.state.Inputs;
    tempInputs[childData.index].Left = childData.left;
    tempInputs[childData.index].Top = childData.top;
    tempInputs[childData.index].Width = childData.width;
    tempInputs[childData.index].Height = childData.height;
    tempInputs[childData.index].RotateAngle = childData.rotateAngle;

    this.setState({ Inputs: tempInputs, ParentUpdate: false });
  };

  componentWillMount() {}

  componentDidMount() {    
    //alert('hello');
    this.loadstate();
    console.log(this.props.match.params.GUID)

    //add html background color
    document.body.style.backgroundColor = '#3b4652';
  }

  componentWillUnmount() {
    //change html background color back
    document.body.style.backgroundColor = '#FFF';
  }

  render() {
    return (
      <div className='App'>
        <Menu />

        <div className="background">
          <div className='View'>
            {
              this.state.loaded && 
              <BackgroundView
                BackgroundColor={this.state.BackgroundColor}
                product={this.state.Product}
              
              />
            }
            {this.state.loaded && this.displayLayers()}

            <br /><br />

            {this.state.loaded &&
              <div className='Payment'>
                <CreatePayment 
                  Product={this.state.Product} 
                  Id={this.state.Id}
                  GUID={this.state.GUID}
                />
                <div className='Spacer'></div>
                <div className='Spacer'></div>
                <div className='Spacer'></div>
                <div className='Spacer'></div>
                
                <Footer />
              </div>
            }        
            </div>
        </div>
      </div>
    );
  }
}

export default View;
